var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0818 30.0017C55.0818 43.7992 44.0654 55.0017 30.4916 55.0017C16.8933 55.0017 5.90146 43.7992 5.90146 30.0017C5.90146 16.1992 16.8933 5.00174 30.4916 5.00174C44.0654 5.00175 55.0818 16.1992 55.0818 30.0017ZM32.6555 39.4767C32.6555 40.6742 31.6719 41.6767 30.4916 41.6767C29.3113 41.6767 28.3522 40.6742 28.3522 39.4767L28.3522 28.4267C28.3522 27.2242 29.3113 26.2517 30.4916 26.2517C31.6719 26.2517 32.6555 27.2242 32.6555 28.4267L32.6555 39.4767ZM30.467 18.2992C31.672 18.2992 32.631 19.2992 32.631 20.4993C32.631 21.6993 31.672 22.6742 30.4916 22.6742C29.2867 22.6742 28.3277 21.6993 28.3277 20.4992C28.3277 19.2992 29.2867 18.2992 30.467 18.2992Z",
    fill: "#FEB111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconLg);
export default __webpack_public_path__ + "static/media/info-icon-lg.fd76bc3803fe77e612451b7e07915963.svg";
export { ForwardRef as ReactComponent };